// extracted by mini-css-extract-plugin
module.exports = {"titleFilter":"index_titleFilter__OZNRz","input":"index_input__AGOwP","suffix":"index_suffix__cqzmZ"};